
import React from 'react';
import { GitBranchIcon, BellIcon } from './icons/FeatureIcons.tsx';

export const StatusBar: React.FC = () => {
  return (
    <footer className="w-full bg-slate-900/70 backdrop-blur-sm border-t border-slate-800 px-4 py-1 flex items-center justify-between text-xs text-slate-400">
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-1 cursor-pointer hover:text-cyan-400 transition-colors">
          <GitBranchIcon />
          <span>main</span>
        </div>
        <div className="flex items-center space-x-1">
          <span>UTF-8</span>
          <span>LF</span>
          <span>2 Spaces</span>
        </div>
      </div>
      <div className="flex items-center space-x-4">
        <span className="hidden sm:block">Ready</span>
        <div className="flex items-center space-x-1 cursor-pointer hover:text-cyan-400 transition-colors">
          <BellIcon />
          <span>0</span>
        </div>
        <span className="hidden sm:block">
          Powered by Gemini
        </span>
      </div>
    </footer>
  );
};